var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showBreadcrumbs)?_c('ViewportWrapper',[_c('UX1Breadcrumb',{attrs:{"items":_vm.breadcrumbsWithoutCurrent,"arrowBack":_vm.showArrow},on:{"click":_vm.handleBreadcrumbClick}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }